var $b2875a923ee4c5ba$exports = {};
$b2875a923ee4c5ba$exports = {
    "valid": `\u{6709}\u{52B9}`
};


export {$b2875a923ee4c5ba$exports as default};
//# sourceMappingURL=ja-JP.module.js.map
